import React from 'react'
import { WidgetFormState } from '../../hooks'
import formStyles from '../../styles/forms.module.scss'
import { getWidgetTypeLabel } from '../../constants/widgetTypes'
import WidgetMetadataEditor from './metadata-editors'
import WidgetTypeSelector from './WidgetTypeSelector'

interface WidgetFormProps {
  state: WidgetFormState
  namePlaceholder?: string
}

const WidgetForm: React.FC<WidgetFormProps> = ({ state, namePlaceholder }) => {
  const { name, setName, type, setType, metadata, setMetadata, widgetId, autoCreating, typeLocked, handleNameBlur } = state

  return (
    <>
      <div className={formStyles.fieldGroup}>
        <label>Widget Type</label>
        {typeLocked ? (
          <span>{getWidgetTypeLabel(type)}</span>
        ) : (
          <WidgetTypeSelector
            value={type}
            onChange={(code) => {
              setType(code)
              setMetadata({})
            }}
          />
        )}
      </div>

      {type && (
        <>
          <div className={formStyles.fieldGroup}>
            <label>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => {
                void handleNameBlur()
              }}
              placeholder={namePlaceholder ?? 'e.g., US Open Hero Banner'}
              disabled={autoCreating}
            />
          </div>

          <WidgetMetadataEditor
            widgetType={type}
            metadata={metadata as Record<string, unknown>}
            onChange={(m) => setMetadata(m)}
            widgetId={widgetId ?? undefined}
          />
        </>
      )}
    </>
  )
}

export default WidgetForm
